/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekdays`)
};

const es_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Días de semana`)
};

const de_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochentage`)
};

const nl_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekdagen`)
};

const fr_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jours de la semaine`)
};

const it_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorni feriali`)
};

const pt_br2_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias úteis`)
};

const pt_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias da semana`)
};

const ja_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平日`)
};

const zh_dd_weekdays = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作日`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_weekdays = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_weekdays(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_weekdays", locale)
	if (locale === "en") return en_dd_weekdays(inputs)
	if (locale === "es") return es_dd_weekdays(inputs)
	if (locale === "de") return de_dd_weekdays(inputs)
	if (locale === "nl") return nl_dd_weekdays(inputs)
	if (locale === "fr") return fr_dd_weekdays(inputs)
	if (locale === "it") return it_dd_weekdays(inputs)
	if (locale === "pt-BR") return pt_br2_dd_weekdays(inputs)
	if (locale === "pt") return pt_dd_weekdays(inputs)
	if (locale === "ja") return ja_dd_weekdays(inputs)
	return zh_dd_weekdays(inputs)
};